// Chat's unknown-outcome notice: a submission whose reply could not be confirmed (P3A-D01). Namespace
// `chat-unconfirmed`; copy by DES1/DES2 (DES2 chat-unconfirmed-24.json).
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  chatUnconfirmed: 'We couldn’t confirm whether this was sent.',
  chatCheckAgain: 'Check again',
};
export type ChatUnconfirmedCopyKey = keyof typeof en;
type Copy = Record<ChatUnconfirmedCopyKey, string>;

const bg: Copy = {
  chatUnconfirmed: 'Не успяхме да потвърдим дали това е изпратено.',
  chatCheckAgain: 'Проверка отново',
};
const cs: Copy = {
  chatUnconfirmed: 'Nepodařilo se ověřit, zda bylo odesláno.',
  chatCheckAgain: 'Zkontrolovat znovu',
};
const da: Copy = {
  chatUnconfirmed: 'Vi kunne ikke bekræfte, om dette blev sendt.',
  chatCheckAgain: 'Tjek igen',
};
const de: Copy = {
  chatUnconfirmed: 'Wir konnten nicht bestätigen, ob dies gesendet wurde.',
  chatCheckAgain: 'Erneut prüfen',
};
const el: Copy = {
  chatUnconfirmed: 'Δεν μπορέσαμε να επιβεβαιώσουμε αν στάλθηκε.',
  chatCheckAgain: 'Έλεγχος ξανά',
};
const es: Copy = {
  chatUnconfirmed: 'No pudimos confirmar si se envió.',
  chatCheckAgain: 'Comprobar de nuevo',
};
const et: Copy = {
  chatUnconfirmed: 'Me ei saanud kinnitada, kas see saadeti.',
  chatCheckAgain: 'Kontrolli uuesti',
};
const fi: Copy = {
  chatUnconfirmed: 'Emme voineet vahvistaa, lähetettiinkö tämä.',
  chatCheckAgain: 'Tarkista uudelleen',
};
const fr: Copy = {
  chatUnconfirmed: 'Nous n’avons pas pu confirmer l’envoi.',
  chatCheckAgain: 'Vérifier à nouveau',
};
const ga: Copy = {
  chatUnconfirmed: 'Níorbh fhéidir linn a dheimhniú ar seoladh é seo.',
  chatCheckAgain: 'Seiceáil arís',
};
const hr: Copy = {
  chatUnconfirmed: 'Nismo mogli potvrditi je li ovo poslano.',
  chatCheckAgain: 'Provjeri ponovno',
};
const hu: Copy = {
  chatUnconfirmed: 'Nem tudtuk megerősíteni, hogy elküldtük-e.',
  chatCheckAgain: 'Ellenőrzés újra',
};
const it: Copy = {
  chatUnconfirmed: 'Non siamo riusciti a confermare se è stato inviato.',
  chatCheckAgain: 'Controlla di nuovo',
};
const lt: Copy = {
  chatUnconfirmed: 'Nepavyko patvirtinti, ar tai išsiųsta.',
  chatCheckAgain: 'Tikrinti dar kartą',
};
const lv: Copy = {
  chatUnconfirmed: 'Mēs nevarējām apstiprināt, vai tas tika nosūtīts.',
  chatCheckAgain: 'Pārbaudīt vēlreiz',
};
const mt: Copy = {
  chatUnconfirmed: 'Ma stajniex nikkonfermaw jekk intbagħatx.',
  chatCheckAgain: 'Iċċekkja mill-ġdid',
};
const nl: Copy = {
  chatUnconfirmed: 'We konden niet bevestigen of dit is verzonden.',
  chatCheckAgain: 'Opnieuw controleren',
};
const pl: Copy = {
  chatUnconfirmed: 'Nie udało się potwierdzić, czy to zostało wysłane.',
  chatCheckAgain: 'Sprawdź ponownie',
};
const pt: Copy = {
  chatUnconfirmed: 'Não foi possível confirmar se foi enviado.',
  chatCheckAgain: 'Verificar novamente',
};
const ro: Copy = {
  chatUnconfirmed: 'Nu am putut confirma dacă a fost trimis.',
  chatCheckAgain: 'Verifică din nou',
};
const sk: Copy = {
  chatUnconfirmed: 'Nepodarilo sa overiť, či bolo odoslané.',
  chatCheckAgain: 'Skontrolovať znova',
};
const sl: Copy = {
  chatUnconfirmed: 'Nismo mogli potrditi, ali je bilo to poslano.',
  chatCheckAgain: 'Preveri znova',
};
const sv: Copy = {
  chatUnconfirmed: 'Vi kunde inte bekräfta om det här skickades.',
  chatCheckAgain: 'Kontrollera igen',
};

export const chatUnconfirmedCopy: NamespaceCatalog<ChatUnconfirmedCopyKey> = {
  bg,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fi,
  fr,
  ga,
  hr,
  hu,
  it,
  lt,
  lv,
  mt,
  nl,
  pl,
  pt,
  ro,
  sk,
  sl,
  sv,
};
export default chatUnconfirmedCopy;
